import GalleryProjects from "@/views/apps/galleries/GalleryProjects";
import GallerySocial from "@/views/apps/galleries/GallerySocial";
import Gallery from "@/views/apps/galleries/Gallery";
import Album from "@/views/apps/galleries/GalleryPhotos";
import layouts from "@/layout";

export default {
  path: "/galleries",
  name: "galleries",
  component: Gallery,
  meta: {
    auth: true
  },
  redirect: {
    name: "galleries-social"
  },
  children: [
    {
      path: "social",
      name: "galleries-social",
      component: GallerySocial,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Gallery Social",
        tags: ["gallery", "social"]
      }
    },
    {
      path: "projects",
      name: "galleries-projects",
      component: GalleryProjects,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Gallery Projects",
        tags: ["gallery", "projects"]
      }
    },
    {
      path: "albums",
      name: "gallery-albums",
      props: (route) => ({ id: route.query.AlbumID }),
      component: Album,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Gallery Projects",
        tags: ["gallery", "projects"]
      }
    }
  ]
};
